module.exports = __webpack_public_path__ + "static/media/TD.7e448065.svg";